<template>
	<div class="main">
	    <div class="logo"></div>
	    <div class="east"></div>
	    <div class="bottom">
	        <a class="login" @click="goLogin">登录</a>
	        <!-- <a class="reg" @click="goRegistUser">注册</a> -->
	        <div class="tips"></div>
	    </div>
	</div>
	
</template>
<script>
	export default {
		name: 'Show',
		data (){
			return {

			}
		},
		mounted(){
			// console.log("打开");
		},
		methods:{
			goLogin (){
				this.$router.push({path: '/Login'})
			},
			goRegistUser (){
				this.$router.push({path: '/RegistUser'})
			}
		}
	}
</script>
<style scoped>
    .main{
        width:7.5rem;min-height:100%;background: #fff;position: fixed;
    }
    .main .bottom{
        position: absolute;bottom: 0.5rem;left:0;width:100%;
    }
    .main .logo{
        width:2.28rem;height:2.28rem;background: url('./../assets/img/logo.png') no-repeat;background-size: cover;margin:2.2rem auto 0;
    }
    .main .east{
        width:4.52rem;height:1.84rem;background: url('./../assets/img/east.png') no-repeat;background-size: cover;margin:0.3rem auto 0;
    }
    .main .login{
        margin:2.8rem auto 0;background: #f84e4e;color:#fff;
    }
    .main .reg{
        margin:0.4rem auto 0;background: #ffeced;color:#f84e4e;
    }
    .main .login,.main .reg{
        display: block;width:5rem;height:0.9rem;line-height: 0.9rem;border-radius: 0.9rem;font-size: 0.36rem;text-align: center;
    }
    .tips{
        width:5rem;font-size: 0.24rem;color:#ff4153;text-align: center;margin: 10px auto 0;line-height: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/pages/show.vue